__turbopack_context__.v({
  "user-headline": "Headline-module-scss-module__65r59W__user-headline",
  "user-headline-container": "Headline-module-scss-module__65r59W__user-headline-container",
});
